import React from 'react';

import { IconProps } from './types';

export const CloseIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="12"
        viewBox="0 0 12 12"
        width="12"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M10.602 0.192308C10.9386 -0.0822502 11.4356 -0.0629051 11.7494 0.250902C12.0631 0.564715 12.0825 1.06174 11.808 1.39836L11.7494 1.46379L7.21231 5.99993L11.7494 10.537L11.809 10.6025C12.0829 10.9391 12.063 11.4354 11.7494 11.7489C11.4359 12.0625 10.9396 12.0824 10.6029 11.8085L10.5375 11.7489L6.0004 7.21184L1.46329 11.7489L1.39786 11.8085C1.06124 12.0825 0.564979 12.0624 0.251372 11.7489C-0.0622188 11.4354 -0.0821647 10.9391 0.191802 10.6025L0.251372 10.537L4.78751 5.99993L0.251372 1.46379L0.192779 1.39836C-0.0817796 1.06169 -0.0624344 0.564708 0.251372 0.250902C0.565179 -0.0629051 1.06217 -0.0822503 1.39883 0.192308L1.46426 0.250902L6.0004 4.78703L10.5365 0.250902L10.602 0.192308Z"
          fill={color}
        />
      </svg>
    );
  },
);
